const header = 'zero_carbon_';
const baseUrl = 'https://portal.zerocarbon.com.pk/iot_api/';
const baseUrlLogin = 'https://portal.zerocarbon.com.pk/api/';
const socketUrl = 'https://portal.zerocarbon.com.pk/socket/';

const operation = {
    getAll: 'GetAll',
    find: 'FindBy',
    insert: 'Insert',
    update: 'Update',
    delete: 'Delete',
};

const config = {
    token: header + 'authentication',
    widget: header + 'widget_box_state',
    currentUser: header + 'current_user',
    currentUsername: header + 'xcewer',
    currentCustomer: header + 'current_customer',
    currentCustomerBackup: header + 'current_customer_backup',
    currentPassword: header + 'xcsewq',
    userRole: header + 'current_user_roles',
    currentPlant: header + 'current_plant',
    customerData: header + 'customer_data',
    solarTime: header + 'solar_timings',
    loginUser: baseUrlLogin + 'auth/SignInWithPlants',
    getDashboard: baseUrl +  'auth/FetchDashBoard',
    getPlantData: baseUrl + 'auth/FetchCompletePlantData',
    getCustomerList: baseUrl + 'auth/FetchCustomersList',
    getPVGraphs: baseUrl + 'auth/FetchPVGraphs',
    getExecutiveDashboard: baseUrl + 'auth/GetExectiveDashboard',
    getPlantsList: baseUrl + 'auth/FetchPlantsList',
    getMonthList: baseUrl + 'auth/DayWiseSavingsData',
    sendInverterState: socketUrl + 'sendState',
    receiveCommand: baseUrl + 'receive_action_command',
    getDeviceId: baseUrl + 'get_device_id_from_serial_id',
    getDayWise: baseUrl + 'auth/DayWiseSavingsData',
    getWeatherData: baseUrl + 'get_weather_data',
    getNetMetered: baseUrl + 'get_net_metered_status_plant',
    getAllPlantsAdmin: baseUrl + 'auth/FetchAllPlantsListClient',
    getPlantAlarms: baseUrl + 'get_all_alarms_client',
    GetReportSubscriptionStatus:baseUrl+'auth/GetReportSubscriptionStatus',
    ChangeReportSubscriptionStatus:baseUrl+'auth/ChangeReportSubscriptionStatus',
    GetPlantsAndInvertersList:baseUrl+'auth/GetPlantsAndInvertersList',
    get_all_alarms_client:baseUrl+'get_all_alarms_client',
    GenerateMonthlyReport:baseUrl+"auth/GenerateMonthlyReport",
    GetGenerateMonthlyReport:baseUrl+"auth/GetGenerateMonthlyReport",
    updatealarmstatus:baseUrl+"update_alarm_status_portal" 

};

export default config;
